<template>
  <BaseDialogCard
    :onPrimaryButtonPressed="onPrimaryButtonPressed"
    :onCancelButtonPressed="onCancelButtonPressed"
    title="Update vessel coordinates"
    primaryButtonText="Update and recompute"
    :dialogModel="dialog"
    :mainButtonDisabled="noTokensRemaining"
  >
    <template #activatorButton="{ on: buttonOn, attrs: buttonAttrs }">
      <v-list-item @click="dialog = true" v-bind="buttonAttrs" v-on="buttonOn">
        <v-list-item-icon>
          <v-icon color="primary">mdi-update</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Update vessel coordinates</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template #icon>
      <v-icon class="mr-1" color="blue">mdi-update</v-icon>
    </template>

    <template #content>
      <RecomputeVoyageDialogContent />
    </template>
  </BaseDialogCard>
</template>

<script>
import BaseDialogCard from "../../../../components/BaseDialogCard.vue";
import RecomputeVoyageDialogContent from "../recompute_voyage/DialogContent.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "UpdateVesselPositionOption",
  components: {
    BaseDialogCard,
    RecomputeVoyageDialogContent,
  },
  data() {
    return {
      options: [
        {
          text: "Recompute",
          icon: "mdi-refresh",
          action: () => (this.dialog = true),
        },
        {
          text: "Export",
          icon: "mdi-export",
          action: () => (this.dialog = true),
        },
        {
          text: "Delete",
          icon: "mdi-delete",
          action: () => (this.dialog = true),
        },
      ],
      dialog: false,
    };
  },
  computed: {
    ...mapGetters("weatherRouting", ["noTokensRemaining"]),
  },
  methods: {
    ...mapActions("weatherRouting/voyageDetailsModule", [
      "getVoyageComputations",
      "getVoyageSolutions",
      "checkSelectedComputationState",
    ]),
    async onPrimaryButtonPressed() {
      this.dialog = false;
      this._initiateVoyageRecalculation();
    },
    onCancelButtonPressed() {
      this.dialog = false;
    },
    async _initiateVoyageRecalculation() {
      await this.$store.dispatch(
        "weatherRouting/voyageDetailsModule/pushVoyageRecalculation",
        {
          voyageId: this.$route.params.voyageId,
          updateVesselPosition: true,
        }
      );
      const voyageId = this.$route.params.voyageId;
      await this.getVoyageComputations(voyageId);
      await this.checkSelectedComputationState(voyageId);
    },
    async _onVoyageRecalculationSuccess(voyageId) {
      await this.$store.dispatch("weatherRouting/fetchCompany");
      await this.getVoyageSolutions({ voyageId: voyageId });
      await this.getVoyageComputations(voyageId);
    },
  },
};
</script>